import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import DeskTopCard from 'src/components/contents/home/titleCard/DeskTopCard';
import MobileCard from 'src/components/contents/home/titleCard/MobileCard';
import { cardZIndex, mobilePoint, padPoint } from 'src/styles/globalStyle';
import { useStore } from 'src/hooks/useStore';

import ImgPatent from 'src/assets/images/tipo_patent.png';
import ImgTrademark from 'src/assets/images/tipo_trademark.png';
import ImgCertificate from 'src/assets/images/tipo_certificate.png';
import ImgCertificateMobile from 'src/assets/images/tipo_certificate_mobile.png';
import ImgPatentHover from 'src/assets/images/tipo_patent_hover.png';
import ImgTrademarkHover from 'src/assets/images/tipo_trademark_hover.png';
import ImgCertificateHover from 'src/assets/images/tipo_certificate_hover.png';
import BgPatent from 'src/assets/images/bg_patent.png';
import BgTradeMark from 'src/assets/images/bg_trademark.png';
import BgCertificate from 'src/assets/images/bg_certificate.png';

import BookHome from 'src/assets/images/img_book_home.png';
import QrBookCert from 'src/assets/images/img_qrbook_certificate.png';
import QrBookCertMobile from 'src/assets/images/img_qrbook_certificate_mobile.png';
import FrameHomeTop from 'src/assets/images/frame_home_top.png';
import FrameHomeDown from 'src/assets/images/frame_home_down.png';
import DotHome from 'src/assets/images/tipo_dot_home.png';
import PlaceImg from 'src/components/ui-kit/PlaceImg';

const Wrapper = styled.div``;
const ImgDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  position: absolute;
  z-index: -1;
  @media (max-width: ${mobilePoint}) {
    display: none;
  }
`;
const InnerWrapper = styled.div`
  margin: 35px 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 39px;
  background-color: rgba(255, 255, 255, 0.6);
  @media (max-width: ${padPoint}) {
    margin: 35px 0px;
    border-radius: 0px;
  }
  @media (max-width: ${mobilePoint}) {
    margin: 20px 20px;
    border-radius: 39px;
  }
`;
const Title = styled.div`
  color: ${colors.BlueGray_700};
  font-family: NotoSansTC-Bold;
  font-size: 34px;
  line-height: 49px;
  margin: 48px 0px 60px 0px;
  cursor: default;
  z-index: ${cardZIndex};
`;
const DesktopContent = styled.div`
  display: flex;
  margin-bottom: 75px;
  gap: 32px;
  z-index: ${cardZIndex};
  @media (max-width: ${mobilePoint}) {
    display: none;
  }
`;
const MobileContent = styled.div`
  display: none;
  @media (max-width: ${mobilePoint}) {
    display: grid;
    gap: 32px;
    padding: 0 10% 10% 10%;
    z-index: ${cardZIndex};
  }
`;

/**
 * 首頁
 */
const Home: React.FC = () => {
  const isMobile = useStore((state) => state.isMobile);
  const isPad = useStore((state) => state.isPad);
  /** 首頁功能項目屬性 */
  const links = [
    {
      href: process.env.PUBLIC_URL + '/patentRights',
      title: '專利權證',
      description: '提供專利權之權利狀態與證書影像查詢。',
      gradientColor: { first: '#692681', second: '#A380D0' },
      image: ImgPatent,
      hoverImage: ImgPatentHover,
      bgImg: BgPatent,
    },
    {
      href: process.env.PUBLIC_URL + '/trademarkRights',
      title: '商標權證',
      description: '提供商標權之權利狀態與證書影像查詢。',
      gradientColor: { first: '#0054CC', second: '#66A5FF' },
      image: ImgTrademark,
      hoverImage: ImgTrademarkHover,
      bgImg: BgTradeMark,
    },
    {
      href: process.env.PUBLIC_URL + '/certificate/verify',
      title: '電子證書',
      description: '提供電子證書驗證與下載服務。',
      gradientColor: { first: '#E99210', second: '#FAB043' },
      image: isMobile ? ImgCertificateMobile : ImgCertificate,
      hoverImage: ImgCertificateHover,
      bgImg: BgCertificate,
    },
  ];

  return (
    <Wrapper>
      {!isMobile && (
        <ImgDiv>
          {!isPad && (
            <>
              <PlaceImg image={BookHome} placeProps={{ height: '304px', top: '50%', left: '0%' }} />
              <PlaceImg
                image={FrameHomeTop}
                placeProps={{ height: '16px', top: '40%', left: '1%' }}
              />
              <PlaceImg
                image={FrameHomeDown}
                placeProps={{ height: '76px', top: '45%', left: '1%', elevation: '-1' }}
              />
              <PlaceImg
                image={QrBookCert}
                placeProps={{ height: '313px', top: '0%', right: '0%' }}
              />
            </>
          )}
          <PlaceImg image={DotHome} placeProps={{ height: '92px', top: '0%', left: '35%' }} />
        </ImgDiv>
      )}
      {isMobile && (
        <ImgDiv>
          <PlaceImg image={BookHome} placeProps={{ height: '200px', top: '-10%', left: '-10%' }} />
          <PlaceImg
            image={QrBookCertMobile}
            placeProps={{ height: '156px', bottom: '-22%', right: '0%' }}
          />
        </ImgDiv>
      )}
      <InnerWrapper>
        <Title><h1>權證查詢系統</h1></Title>
        <DesktopContent>
          {links.map((item) => {
            return (
              <DeskTopCard
                href={item.href}
                title={item.title}
                description={item.description}
                gradientColor={item.gradientColor}
                image={item.image}
                hoverImage={item.hoverImage}
                bgImg={item.bgImg}
                key={item.title}
              />
            );
          })}
        </DesktopContent>
        <MobileContent>
          {links.map((item) => {
            return (
              <MobileCard
                href={item.href}
                title={item.title}
                description={item.description}
                gradientColor={item.gradientColor}
                image={item.image}
                hoverImage={item.hoverImage}
                bgImg={item.bgImg}
                key={item.title}
              />
            );
          })}
        </MobileContent>
      </InnerWrapper>
    </Wrapper>
  );
};

export default Home;
